const whichAnimationEvent = function() {
	let t;
	const el = document.createElement( 'fakeelement' );

	var animations = {
		animation      : 'animationend',
		OAnimation     : 'oAnimationEnd',
		MozAnimation   : 'animationend',
		WebkitAnimation: 'webkitAnimationEnd',
	};

	for ( t in animations ) {
		if ( el.style[ t ] !== undefined ) {
			return animations[ t ];
		}
	}

	return false;
};

const whichTransitionEvent = function() {
	let t;
	const el = document.createElement( 'fakeelement' );

	const transitions = {
		transition      : 'transitionend',
		OTransition     : 'oTransitionEnd',
		MozTransition   : 'transitionend',
		WebkitTransition: 'webkitTransitionEnd',
	};

	for ( t in transitions ) {
		if ( el.style[ t ] !== undefined ) {
			return transitions[ t ];
		}
	}

	return false;
};

let animationEvent = null;

const getSupportedAnimationEndEvent = function() {
	if ( null === animationEvent ) {
		animationEvent = whichAnimationEvent();
	}

	return animationEvent;
};

let transitionEvent = null;

const getSupportedTransitionEndEvent = function() {
	if ( null === transitionEvent ) {
		transitionEvent = whichTransitionEvent();
	}

	return transitionEvent;
};

export default {};
export {
	getSupportedAnimationEndEvent,
	getSupportedTransitionEndEvent,
};
